import React from 'react'
import { IconButton } from '@mui/material'
import { Menu as MenuIcon } from '@mui/icons-material'
import { toggleDrawerOpen } from '../../../SideDrawer/DesktopDrawer/drawerOpen.store'

const ExpanderToggle: React.VFC = () => {
    return (
        <IconButton color="primary" aria-label="open drawer" onClick={toggleDrawerOpen} edge="start">
            <MenuIcon />
        </IconButton>
    )
}

export default ExpanderToggle
